import React, { memo, useEffect, useMemo, useState } from 'react'
import { CustomerPlusMajor } from '@shopify/polaris-icons'
import { useSelector } from 'react-redux'
import { getMCOnboardingCounts } from 'src/selectors/mcOnboarding'
import { colors } from 'src/theme'
import { addS } from 'src/utils/baseUtils'
import { TableTab, TableTabs } from 'src/components/shared/table/table-tabs/TableTabs'
import { MCStatus } from 'src/constants/mc/enums'

interface Props {
  selectedTab: MCStatus
  onClick(tab: MCStatus): void
}

const MCOnboardingTabsComponent = ({ selectedTab, onClick }: Props) => {
  const mcOnboardingCounts = useSelector(getMCOnboardingCounts)
  const [counts, setCounts] = useState<Partial<Record<MCStatus, number>>>()

  useEffect(() => {
    setCounts({
      [MCStatus.Invited]: mcOnboardingCounts?.invitedCount || 0,
    })
  }, [mcOnboardingCounts])

  const tabs = useMemo(() => {
    const res: TableTab<MCStatus>[] = [
      {
        value: MCStatus.Invited,
        title: 'Invited MC',
        renderIcon: (selected: boolean) => (
          <CustomerPlusMajor
            width={20}
            height={20}
            fill={selected ? colors.PRIMARY_PURPLE_600 : colors.GRAY_BLACK}
          />
        ),
      },
    ]

    return res.map((item) => ({
      ...item,
      subtitle: counts
        ? `${counts[item.value] || 0} ${addS(counts[item.value] || 0, 'master contractor')}`
        : '',
    }))
  }, [counts])

  return <TableTabs<MCStatus> tabs={tabs} selectedValue={selectedTab} onClick={onClick} />
}

export const MCOnboardingTabs = memo(MCOnboardingTabsComponent)
